import React from "react";

import { Grid } from "@mui/material";
import classNames from "classnames";
import { DespatchTask } from "Models/despatch.task";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../../components/Form/Button";
import useStyles from "./styles";

interface ConfirmationCancelTaskProps {
  modalOpened: boolean;
  setModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
  task: DespatchTask;
  onConfirm: (task: DespatchTask) => void;
}

export const ConfirmationCancelTask: React.FC<ConfirmationCancelTaskProps> = ({
  modalOpened,
  setModalOpened,
  task,
  onConfirm,
  loading,
}) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <ConfirmationModal
      width="520px"
      open={modalOpened}
      closeModal={() => setModalOpened(false)}
      type="error"
      loading={loading}
      title={translate("cancelTask")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("back")}
      textSubmit={translate("yesCancelTask")}
      submit={() => onConfirm(task)}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item xs={12} className={classes.description}>
          <span>{translate("areYouSureYouWantToCancelThisTask")}</span>
        </Grid>
        <Grid item xs={12} className={classNames(classes.description, classes.error, "mt-2")}>
          <span>{translate("thisActionIsPermanentAndCannotBeUndone")}</span>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};
